import { computed } from 'vue';
import store from '@shared/store/index';
import { useGlobalScrollLock } from '@shared/composables/lockGlobalScroll/lockGlobalScroll';
import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName';

const { scrollWidth } = useGlobalScrollLock();

const open = () => {
  store.dispatch('Dropdowns/addNewDropdown', DROPDOWN_NAMES.notifications)
}

const close = () => {
  store.dispatch('Dropdowns/removeTheDropdown', DROPDOWN_NAMES.notifications)
}

const isOpen = computed(() => store.getters['Dropdowns/isInList'](DROPDOWN_NAMES.notifications));

export function useNotificationsDropdown(){
  return{
    open,
    close,
    isOpen,
    scrollWidth,
  }
}